module.exports = __webpack_public_path__ + "static/how-to-create-brand__step-3-301a3e18c0944fd584288f0b0da34e4f.png";